// loading spinner
//import spinner css
import "./Loader.css";
export default function Loader() {
  return <div className="loading">Loading&#8230;</div>;
}
